(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookStatisticDetailController', HandbookStatisticDetailController);

    HandbookStatisticDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookStatistic', 'Handbook'];

    function HandbookStatisticDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookStatistic, Handbook) {
        var vm = this;

        vm.handbookStatistic = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookStatisticUpdate', function(event, result) {
            vm.handbookStatistic = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
